var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"services"},[_c('div',{staticClass:"services__pricing"},[_vm._l((_vm.servicesData.pricingOptions),function(pricingItem,index){return _c('ServicesBlock',{key:index,attrs:{"pricing-item":pricingItem},on:{"click":_vm.onServiceClick}})}),_c('PricingServicesPopups')],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }